"use strict";

var _jsxRuntime = require("react/jsx-runtime");

module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M16.482 19.495c.324-.313.505-.736.505-1.177 0-.442-.18-.865-.505-1.178l-5.37-5.146 5.37-5.099c.331-.317.517-.748.518-1.197.001-.45-.183-.88-.513-1.2A1.794 1.794 0 0 0 15.244 4c-.467 0-.915.177-1.245.494L7.5 10.789a1.637 1.637 0 0 0-.379.553 1.59 1.59 0 0 0-.12.652 1.623 1.623 0 0 0 .5 1.215l6.5 6.286c.16.16.353.287.567.374.432.175.916.175 1.348 0 .213-.087.406-.214.567-.374Z"
  })]
});